import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactElement } from 'react';
import { Provider } from 'react-redux';

import history from 'browserHistory';
import SnackbarNotificationContainer from 'components/Snackbars/SnackbarNotificationContainer';
import { AuthProvider } from 'contexts/AuthContext';
import MUIThemeProvider from 'contexts/MUIProvider';
import { ResponsiveProvider } from 'contexts/ResponsiveContext';
import { StyledThemeProvider } from 'contexts/StyledThemeProvider';
import GlobalStyle from 'GlobalStyle';
import store from 'reduxStore/store';
import AppRoutes from 'router/AppRoutes';
import Router from 'router/Router';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

function App(): ReactElement {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <SnackbarNotificationContainer />
        <AuthProvider>
          <ResponsiveProvider>
            <MUIThemeProvider>
              <StyledThemeProvider>
                <Router history={history}>
                  <GlobalStyle />
                  <AppRoutes />
                </Router>
              </StyledThemeProvider>
            </MUIThemeProvider>
          </ResponsiveProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
